import { Button, Divider, Flex, Form, Input, Modal } from 'antd'
import type { TextAreaRef } from 'antd/es/input/TextArea'
import { useUnit } from 'effector-react'
import { useEffect, useRef } from 'react'
import { useModalRequestComment } from 'src/pages/budget/budgetRequests/hooks'
import {
  closeModalRequestComment,
  postCommentRequestsFx,
} from 'src/pages/budget/budgetRequests/model'
import { LinkifiedText, UiText } from 'src/pages/budget/components'
import { REQUIRED_FIELD } from 'src/pages/budget/const'

type FormValues = {
  message: string
}

export const ModalRequestComment = () => {
  const [form] = Form.useForm<FormValues>()
  const messageInputRef = useRef<TextAreaRef>(null)
  const modalRequestComment = useModalRequestComment()
  const loading = useUnit(postCommentRequestsFx.pending)

  useEffect(() => {
    if (!modalRequestComment) return

    const frameId = requestAnimationFrame(() => {
      messageInputRef.current?.focus()
    })

    return () => cancelAnimationFrame(frameId)
  }, [modalRequestComment])

  if (!modalRequestComment) return null

  const { id, description } = modalRequestComment
  const open = Boolean(modalRequestComment)

  const handleCancel = () => {
    form.resetFields()
    closeModalRequestComment()
  }

  const handleOk = async () => {
    try {
      const { message } = await form.validateFields()

      await postCommentRequestsFx({
        body: {
          message,
          department: '',
          entityId: String(id),
          entityType: 'budget_request',
          type: 2,
          visibility: 'all',
        },
      })
      handleCancel()
    } catch (error) {
      console.error('validation error или ошибка запроса')
    }
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Комментарий</div>}
      centered
      wrapClassName="ant_modal"
      width={500}
      maskClosable={false}
      open={open}
      destroyOnHidden
      afterOpenChange={(visible) => {
        if (visible) {
          requestAnimationFrame(() => messageInputRef.current?.focus())
        }
      }}
      onCancel={handleCancel}
      footer={
        <Flex gap={8}>
          <Button size="large" style={{ flex: 1 }} onClick={handleCancel}>
            Отменить
          </Button>
          <Button
            size="large"
            variant="solid"
            color="blue"
            style={{ flex: 1 }}
            onClick={handleOk}
            loading={loading}
          >
            Отправить
          </Button>
        </Flex>
      }
    >
      <Divider />

      <UiText size={18}>
        Вы уверены, что хотите оставить комментарий к заявке №
        <UiText size={18} strong>
          {id} <LinkifiedText text={description} />
        </UiText>
      </UiText>

      <Form form={form} layout="vertical">
        <Form.Item
          name="message"
          rules={[
            {
              required: true,
              whitespace: true,
              message: REQUIRED_FIELD,
            },
          ]}
          style={{ marginTop: 24 }}
        >
          <Input.TextArea
            ref={messageInputRef}
            autoFocus
            rows={3}
            placeholder="Comment"
          />
        </Form.Item>
      </Form>

      <Divider />
    </Modal>
  )
}
